import { createAction, props } from '@ngrx/store';
import { IFormContentData, IFormPreviewGroup, ISignatureData, ISignatureModel } from '@partners/api';
import { IRemoteError } from '@partners/errors';

export class SignatureActions {
  static reset = createAction('[Signature] Reset State');

  static loadFormContent = createAction('[Signature] Load Form Content', props<{ fileId: number }>());
  static loadFormContentSuccess = createAction(
    '[Signature] Load Form Content Success',
    props<{ formContent: IFormContentData }>()
  );
  static loadFormContentFailure = createAction(
    '[Signature] Load Form Content Failure',
    props<{ error: IRemoteError }>()
  );

  static loadFormsPreview = createAction('[Signature] Load Forms Preview');
  static loadFormsPreviewSuccess = createAction(
    '[Signature] Load Forms Preview Success',
    props<{ model: ISignatureModel; data: ISignatureData }>()
  );
  static loadFormsPreviewFailure = createAction(
    '[Signature] Load Forms Preview Failure',
    props<{ error: IRemoteError }>()
  );

  static updateFormStatus = createAction('[Signature] Update Form Status');
  static updateFormStatusSuccess = createAction(
    '[Signature] Update Form Status Success',
    props<{ groupPreview: IFormPreviewGroup }>()
  );
  static updateFormStatusFailure = createAction(
    '[Signature] Update Form Status Failure',
    props<{ error: IRemoteError }>()
  );

  static submit = createAction('[Signature] Submit', props<{ model: ISignatureModel }>());
  static submitSuccess = createAction('[Signature] Submit Success', props<{ data: ISignatureData }>());
  static submitFailure = createAction('[Signature] Submit Failure', props<{ error: IRemoteError }>());
}
